import {
    Component,
    Input,
    OnDestroy,
    OnInit,
    ChangeDetectionStrategy,
} from '@angular/core';
import { UserStateService } from '../../../modules/user/shared/services/user-state/user-state.service';
import { Subject, takeUntil } from 'rxjs';
import { AuthenticatedUser } from '../../../core/models/authenticated-user';
import { MatButtonModule } from '@angular/material/button';
import { MasqueradeService } from '../../../modules/user/shared/services/masquerade/masquerade.service';

@Component({
    selector: 'app-masquerade-header',
    templateUrl: './masquerade-header.component.html',
    styleUrl: './masquerade-header.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButtonModule],
})
export class MasqueradeHeaderComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    @Input() topMarginClass: string = '-mt-3';

    isMasqueraded = false;
    firstName: string | undefined = undefined;
    lastName: string | undefined = undefined;

    constructor(
        private readonly userStateService: UserStateService,
        private readonly masqueradeService: MasqueradeService,
    ) {}

    ngOnInit(): void {
        this.subscribeToCurrentUser();
    }

    stopMasquerading(): void {
        this.masqueradeService.stopMasquerading();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private subscribeToCurrentUser() {
        this.userStateService.user$
            .pipe(takeUntil(this.destroy$))
            .subscribe((user: AuthenticatedUser | null) => {
                this.isMasqueraded = user?.isMasqueraded ?? false;
                this.firstName = user?.firstName;
                this.lastName = user?.lastName;
            });
    }
}
